import React from 'react';
import {t} from '@lingui/core/macro';

import CheckMark from 'shared/ui/CheckMark/CheckMark';

import {IFreeTariffFact} from '../../lib/freeTariffFacts';

import styles from './FreePlan.module.scss';

interface IFreePlanProps {
    facts: IFreeTariffFact[],
}

const FreePlan: React.FC<IFreePlanProps> = ({facts}) => (
    <div className={styles.plan}>
        <div className={styles.head}>
            <span className={styles.title}>{t`На бесплатном тарифе`}</span>
            <span className={styles.note}>{t`уже сейчас, без карты`}</span>
        </div>
        <ul className={styles.list}>
            {facts.map(({value, caption}) => (
                <li className={styles.item} key={value}>
                    <CheckMark size="sm"/>
                    <span>
                        <b className={styles.value}>{value}</b>
                        <span className={styles.caption}>{caption}</span>
                    </span>
                </li>
            ))}
        </ul>
    </div>
);

export default FreePlan;
